<div class="m-portlet">
	<div class="m-portlet__head">
		<div class="m-portlet__head-progress">
			<mat-progress-bar mode="indeterminate"></mat-progress-bar>
		</div>
		<div class="m-portlet__head-caption">
			<div class="m-portlet__head-title">
				<h3 class="m-portlet__head-text">
					{{data.title}}
				</h3>
			</div>
		</div>
	</div>
	<div class="m-form">
		<div class="m-portlet__body">
			<div class="form-group m-form__group row">
				<div class="col-lg-12">
					{{ data.waitDesciption}}
				</div>
			</div>
		</div>
		<div class="m-portlet__foot m-portlet__no-border m-portlet__foot--fit text-right">
			<div class="m-form__actions m-form__actions--sm">
				<button mat-button (click)="onNoClick()">İptal</button>
			</div>
		</div>
	</div>
</div>